export const rateSource = {
  internal: "internal",
  online: "online",
};
